import { pluralize } from "@suse-o11y/pluralize";
import React, { type FC } from "react";

import { Button } from "~/components/button";
import { Truncated } from "~/components/truncated";

import { TRIAL_LINK } from "../../components/react/docLink/AllDocLinkSlugs";
import { Link } from "../../components/react/link";

const pluralizeDays = pluralize({
	0: "less than 1 day",
	1: "1 day",
	more: (d) => `${d} days`,
});

export const OnlineTrialMessage: FC<{ daysLeftToExpire: number }> = ({ daysLeftToExpire }) => {
	const message = `${pluralizeDays(daysLeftToExpire)} left out of your trial`;

	return (
		<div className="flex min-w-0 flex-row items-center overflow-hidden">
			<Truncated className="min-w-14">{message}</Truncated>{" "}
			<Link el="a" href={TRIAL_LINK} target="_blank" theme="unstyled">
				<Button
					className="mx-2 bg-white uppercase"
					data-testid="contact-us-button"
					size="sm"
					title="Contact us"
					variant="tertiary"
				>
					Contact us
				</Button>
			</Link>
		</div>
	);
};
